module.exports = __webpack_public_path__ + "img/logo_1.d558ca64.png";